import React, { CSSProperties, ReactNode } from 'react';
import { ArrowLeftIcon } from '../../assets/icons/ArrowLeftIcon';
import { getMergedClassNames } from '../../utils/HTMLutils';
import IconButton from '../iconButton/IconButton';
import './Title.scss';
const rootClassName = 'component-title';

interface TitleProps {
  children: any;
  showBackButton?: boolean;
  onBackClick?: (event?: any) => void;
  oneLineTitle?: boolean;
  rightElement?: ReactNode;
  hideRightElementXS?: boolean;
  align?: CSSProperties['alignItems'];
  flexWrap?: CSSProperties['flexWrap'];
}

export default function Title(props: TitleProps) {
  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        props.hideRightElementXS ? 'hide-right-xs' : '',
      ])}
      style={{ alignItems: props.align, flexWrap: props.flexWrap }}
    >
      <div className={`${rootClassName}-wrapper`}>
        {props.showBackButton ? (
          <div className={`${rootClassName}-icon`}>
            <IconButton icon={<ArrowLeftIcon />} onClick={props.onBackClick} />
          </div>
        ) : undefined}
        <div
          className={getMergedClassNames([
            `${rootClassName}-text`,
            props.oneLineTitle ? 'one-line-title' : '',
          ])}
        >
          {props.children}
        </div>
      </div>
      {props.rightElement ? (
        <div className={`${rootClassName}-right-element`}>
          {props.rightElement}
        </div>
      ) : undefined}
    </div>
  );
}

Title.defaultProps = {};
